export const scrollBrowserWindowToTop = () => {
  window.scrollTo({
    behavior: 'auto',
    top: 0
  });
};
